export default {
  FETCH_HU_LOCAL_RESULTS: 'FETCH_HU_LOCAL_RESULTS',
  FETCH_HU_LOCAL_RESULTS_SUCCESS: 'FETCH_HU_LOCAL_RESULTS_SUCCESS',
  FETCH_HU_LOCAL_RESULTS_FAILURE: 'FETCH_HU_LOCAL_RESULTS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/local/actionTypes.js